module.exports = __webpack_public_path__ + "c4dfacfaa1699f19bed622d427787194.png";